module.exports = __webpack_public_path__ + "img/selfServiceImg1.3d2a17e.svg";